(function ($) {
    $.fn.toggleCard = function () {
        var $self = $(this);
        var $elements = $self.find('.js-toggle-card-element');
        var widthScreen = parseInt($self.css('width'));
        var tabletWidth = 768;
        var desktopWidth = 1265;
        var heightWrapper = parseInt($self.css('height'));
        var newHeightWrapper;

        var init = function () {
            $elements.each(function (index) {
                $(this).on('click', function () {
                    if(widthScreen < tabletWidth) {
                        toggleClass($(this));
                    } else if (widthScreen < desktopWidth) {
                        removeTransform();
                        movesNextElement(index);
                    } else {
                        return;
                    }
                });
            });
        };

        var movesNextElement = function (index) {
            var $clickedElement = $elements.eq(index);
            var $nextElement = $elements.eq(index + 1);
            var negativeMarginBottom = parseInt($clickedElement.css('marginBottom'));
            if (negativeMarginBottom >= 0) {
                toggleClass($clickedElement);
                return;
            }
            negativeMarginBottom = negativeMarginBottom * -1;
            newHeightWrapper = heightWrapper + negativeMarginBottom;
            toggleClass();
            removeTransform();
            if($clickedElement.hasClass('clicked')) {
                $clickedElement.removeClass('clicked');
                return;
            }
            $clickedElement.addClass('clicked');
            $nextElement.css({'transform': 'translateY(110px)'});
            $self.css({'height': newHeightWrapper});
        };

        var toggleClass = function (element) {
            if (element && element.hasClass('open')) {
                element.removeClass('open');
                return;
            }
            $elements.each(function () {
                $(this).removeClass('open');
            });
            if(element) {
                element.addClass('open');
            }
        };

        var removeTransform = function () {
            $self.css({'height': 'auto'});
            $elements.each(function () {
                $(this).css({'transform': 'translateY(0)'});
            });
        };

        init();
    };

    $('.js-toggle-card').each(function () {
        $(this).data('toggleCard', $(this).toggleCard());
    });
})(jQuery);
